module.exports = {"apiUrl":{"development":"/","production":"/api"},"developmentOptions":{"apiServerPort":"9001","ignoreFullfillment":false}}


//////////////////
// WEBPACK FOOTER
// ./src/app-config.json
// module id = 401
// module chunks = 0